import * as ZonesSubscriptionsActions from '../actions/zones-subscriptions.actions';
import * as ZonesSubscriptionsApiActions from '../actions/zones-subscriptions-api.actions';
import { ZoneSubscription } from '../../../zones/models/zone-subscription';
import { EntryTypeEnum } from '../../../zones/models/entry-type.enum';

export interface State {
  error: any;
  zonesSubscriptions: ZoneSubscription[];
}

export const initialState: State = {
  error: null,
  zonesSubscriptions: null,
}

export function reducer(
  state = initialState,
  action: ZonesSubscriptionsActions.ZonesSubscriptionsActionsUnion | ZonesSubscriptionsApiActions.ZonesSubscriptionsApiActionsUnion
): State {
  switch (action.type) {
    case ZonesSubscriptionsApiActions.getZonesSubscriptionsFailure.type:
    case ZonesSubscriptionsApiActions.createZoneSubscriptionFailure.type:
    case ZonesSubscriptionsApiActions.editZoneSubscriptionFailure.type:
    case ZonesSubscriptionsApiActions.editUnitsZoneSubscriptionFailure.type:
    case ZonesSubscriptionsApiActions.deleteZoneSubscriptionFailure.type:
    case ZonesSubscriptionsApiActions.changeStateFailure.type: {
      return {
        ...state,
        error: action.error
      };
    }
    case ZonesSubscriptionsApiActions.getZonesSubscriptionsSuccess.type: {
      return {
        ...state,
        zonesSubscriptions: action.data
      };
    }
    case ZonesSubscriptionsApiActions.createZoneSubscriptionSuccess.type: {
      return {
        ...state,
        zonesSubscriptions: [...state.zonesSubscriptions, action.data]
      };
    }
    case ZonesSubscriptionsApiActions.editZoneSubscriptionSuccess.type: {
      const newZonesSubscriptions = [...state.zonesSubscriptions];
      const index = newZonesSubscriptions.findIndex(zone => zone.zoneSubscriptionId === action.data.zoneSubscriptionId);
      newZonesSubscriptions[index] = {
        ...action.data,
        unitIds: newZonesSubscriptions[index].unitIds
      };
      return {
        ...state,
        zonesSubscriptions: newZonesSubscriptions
      };
    }
    case ZonesSubscriptionsApiActions.editUnitsZoneSubscriptionSuccess.type: {
        const newZonesSubscriptions = [...state.zonesSubscriptions];
        const index = newZonesSubscriptions.findIndex(zone => zone.zoneSubscriptionId === action.data.zoneSubscriptionId);
        if (index > -1) {
            newZonesSubscriptions[index].unitIds = action.data.unitIds;
        }
        return {
            ...state,
            zonesSubscriptions: newZonesSubscriptions
        };
    }
    case ZonesSubscriptionsApiActions.deleteZoneSubscriptionSuccess.type: {
      const newZonesSubscriptions = state.zonesSubscriptions.filter(zone => zone.zoneSubscriptionId !== action.zoneId);
      return {
        ...state,
        zonesSubscriptions: newZonesSubscriptions
      };
    }

    case ZonesSubscriptionsApiActions.changeStateSuccess.type: {
      const newZonesSubscriptions = [...state.zonesSubscriptions];
      const zoneSubscription = newZonesSubscriptions.find(zone => zone.zoneSubscriptionId === action.data.zoneSubscriptionId);
      if (zoneSubscription) {
        if (action.data.entryType === EntryTypeEnum.Entry) {
          zoneSubscription.zoneRegionIn = action.data.entryState;
        } else if (action.data.entryType === EntryTypeEnum.Leave) {
          zoneSubscription.zoneRegionOut = action.data.entryState;
        }
      }
      return {
        ...state,
        zonesSubscriptions: newZonesSubscriptions
      };
    }
    default: {
      return state;
    }
  }
}
export const getError = (state: State) => state.error;
export const getZonesSubscriptions = (state: State) => state.zonesSubscriptions;
export const getZonesSubscriptionById = (state: State, zoneId: number) => state?.zonesSubscriptions?.find(z => z.zoneSubscriptionId === zoneId);
